import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export default function TabContainer({ children }) {
    return (
        <Typography component="div" className="flex_full padding_top_24  padding_bottom_24">
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/complex/alerts/TabContainer.js